import { ThemeType } from '@shared/lib/theme'

export const toastSizes = {
  l: 'l',
  m: 'm',
}

export const toastVariants: Record<keyof ThemeType['colors']['toast'], keyof ThemeType['colors']['toast']> = {
  success: 'success',
  error: 'error',
  warning: 'warning',
  info: 'info',
}

export const toastPaddingsRem = {
  [toastSizes.l]: '12px 44px 12px 12px',
  [toastSizes.m]: '4px 44px 8px 12px',
}

export const toastPaddingsPx = {
  [toastSizes.l]: '12px 44px 12px 12px',
  [toastSizes.m]: '4px 44px 8px 12px',
}

export const toastTitleTextSizesDesktop = {
  [toastSizes.l]: 'pM',
  [toastSizes.m]: 'pS',
} as const

export const toastTitleTextSizesMobile = {
  [toastSizes.l]: 'pM',
  [toastSizes.m]: 'pS',
} as const

export const toastDescriptionTextSizesDesktop = {
  [toastSizes.l]: 'pS',
  [toastSizes.m]: 'captionL',
} as const

export const toastDescriptionTextSizesMobile = {
  [toastSizes.l]: 'pS',
  [toastSizes.m]: 'captionL',
} as const

export const toastBorderRadiusesRem = {
  [toastSizes.l]: '1.25rem',
  [toastSizes.m]: '1rem',
}

export const toastBorderRadiusesPx = {
  [toastSizes.l]: '20px',
  [toastSizes.m]: '16px',
}
